import React from 'react';
import Wrapper from 'components/wrapper';
import MetaTags from 'components/meta-tags';
import { CheckoutProvider, contextStore } from 'checkout/context';
import CheckoutContainer from 'checkout/isolated/container';
import { isolatedContextStore, IsolatedCheckoutProvider } from 'checkout/isolated/context';
import { AerosyncPreAuthProvider } from 'src/payments/components/aerosync-pre-auth/context/aerosync-pre-auth-provider';
import { ModalWrapper } from 'shared/modals/v2-wrapper';
import CriticalAnnouncementModal from 'components/modals/critical-announcement-modal/critical-announcement-modal';
import useCriticalAnnouncementModal from 'hooks/use-critical-announcement-modal';

function CheckoutsPage() {
  const {
    showModal: showAnnouncementModal,
    modalConfig,
    closeModal: closeAnnouncementModal,
  } = useCriticalAnnouncementModal();

  return (
    <Wrapper>
      <MetaTags customRobotsRule='noindex,nofollow' />
      <CheckoutProvider value={contextStore}>
        <IsolatedCheckoutProvider value={isolatedContextStore}>
          <AerosyncPreAuthProvider>
            <CheckoutContainer />
          </AerosyncPreAuthProvider>
        </IsolatedCheckoutProvider>
      </CheckoutProvider>

      {/* Critical Announcement Modal */}
      <ModalWrapper open={showAnnouncementModal} onClose={closeAnnouncementModal}>
        <CriticalAnnouncementModal containerProps={{}} onClose={closeAnnouncementModal} config={modalConfig} />
      </ModalWrapper>
    </Wrapper>
  );
}

CheckoutsPage.hideAppHeader = true;
CheckoutsPage.hideAppFooter = true;

export default CheckoutsPage;
